/** Gift box assembly instructions — portrait on mobile, landscape on tablet/desktop. */

export const ASSEMBLY_CATALOGUE_IMAGE = `${process.env.PUBLIC_URL}/catalogue/gift-box-assembly-guide.jpeg`;

export const ASSEMBLY_CATALOGUE_IMAGE_LANDSCAPE = `${process.env.PUBLIC_URL}/catalogue/landscape_catologue.png`;

export const ASSEMBLY_CATALOGUE_ALT =
  "Gift box assembly guide — how to fold, seal, and tie your Rencin Gifting box";

/** min-width for landscape catalogue (tablets + desktops). */
export const ASSEMBLY_CATALOGUE_LANDSCAPE_MEDIA = "(min-width: 768px)";
